// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ConfirmResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/confirm/{id}
 *
 * Returns the order id and its new status after confirmation.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_ConfirmResponseDados {
order_id: number
status: string
}

export type Orders_ConfirmResponse = ApiResponse<Orders_ConfirmResponseDados>;

registerResponseContract('Orders_ConfirmResponse', {
  order_id: { type: 'number',  required: true },
  status:   { type: 'string',  required: true },
})
